module.exports = "//cdn.mxpnl.com/static/asset-cache/ffe4c7759a85134bb870f14af9162725/iron/common/widgets/warning-hero/images/empty-dashboards.svg";